import React, { useRef, useEffect } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

// Импортируем модули
import htmlEditButton from 'quill-html-edit-button';
import ImageCompress from 'quill-image-compress';
import TableUI from 'quill-table-ui';

// Регистрируем модули
Quill.register('modules/htmlEditButton', htmlEditButton);
Quill.register('modules/imageCompress', ImageCompress);
Quill.register('modules/tableUI', TableUI);

const RichTextEditor = ({ 
  value, 
  onChange, 
  currentLang = 'en',
  placeholder = '',
  className = ''
}) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const isUpdatingRef = useRef(false);

  // Инициализация Quill
  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      const quill = new Quill(editorRef.current, {
        theme: 'snow',
        modules: {
          table: true,
          tableUI: true,
          htmlEditButton: {},
          imageCompress: {
            quality: 0.8, // default
            maxWidth: 1400, // default
            maxHeight: 1000, // default
            imageType: 'image/jpeg', // default
            debug: true, // default
            suppressErrorLogging: false, // default
            handleOnPaste: true, //default 
            insertIntoEditor: undefined, // default
          },
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['blockquote', 'code-block'],
            ['link', 'table', 'image', 'video', 'clean']
          ],
          
        },
        placeholder: placeholder || (currentLang === 'ru' ? 'Введите описание задачи...' : 'Enter task description...')
      });

      // Обработчик изменений
      quill.on('text-change', function() {
        if (!isUpdatingRef.current) {
          const html = quill.root.innerHTML;
          if (html !== '<p><br></p>') {
            onChange(html);
          }
        }
      });

      // Добавляем кастомную иконку для таблицы
      const tableButton = quill.getModule('toolbar').container.querySelector('.ql-table');
      if (tableButton) {
        tableButton.innerHTML = `
          <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h10v2H7v-2z"/>
          </svg>
        `;
      }

      // Добавляем кастомную иконку для HTML редактирования
      setTimeout(() => {
        const htmlButton = document.querySelector('button[title="Show HTML source"]');
        if (htmlButton) {
          htmlButton.innerHTML = `
            <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
            </svg>
          `;
          htmlButton.style.cssText = `
            background: none;
            border: none;
            cursor: pointer;
            padding: 3px 5px;
            margin: 0 1px;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
          `;
        }
      }, 100);

      quillRef.current = quill;

      // Устанавливаем начальное содержимое
      if (value && value !== '<p><br></p>') {
        isUpdatingRef.current = true;
        quill.root.innerHTML = value;
        isUpdatingRef.current = false;
      }
    }
  }, [currentLang, placeholder, onChange]);

  // Обновляем содержимое при изменении value извне
  useEffect(() => {
    if (quillRef.current && value !== quillRef.current.root.innerHTML) {
      isUpdatingRef.current = true;
      quillRef.current.root.innerHTML = value || '';
      isUpdatingRef.current = false;
    }
  }, [value]);

  // Очистка при размонтировании
  useEffect(() => {
    return () => {
      if (quillRef.current) {
        quillRef.current = null;
      }
    };
  }, []);

  return (
    <div className={`rich-text-editor ${className}`}>
      <div className="overflow-hidden">
        <div ref={editorRef} className="min-h-96" style={{ minHeight: '200px' }} />
      </div>
    </div>
  );
};

export default RichTextEditor; 